<template>
	<div>
		<v-card style="margin-top: 15px;">
			<s-toolbar label="Parihuelas abastecidas" dark color="#8e8f91"></s-toolbar>
			<v-container>
				<v-row style="margin: auto" justify="center">
					<v-col cols="8" lg="3" md="3">
						<s-text
							label="N° Lote Produccion"
							v-model="RcfID"
							autofocus
							ref="rcffocus"
							@keyupEnter="clickSearch()"
							@input="clickSearch()"
	
						>
						</s-text>
					</v-col>
					<v-col cols="4" lg="3" md="3">
						<v-btn
							style="margin-top: 10px;"
							:color="'success'"
							@click="clickSearch()"
							>Buscar</v-btn
						>
					</v-col>
					<!-- <v-col cols="4" lg="3" md="3">
						<s-select-campaign-area
							label="Campaña"
							v-model="CmaId"
							typeArea="3"
							clerable									
						></s-select-campaign-area>
					</v-col> -->
					<v-col cols="12" md="3"><s-turn-in-process clearable :TypeArea="5" v-model="TrnID"></s-turn-in-process></v-col>
				</v-row>
			</v-container>
		</v-card>
		<v-card style="margin-top: 5px;">
			<s-toolbar label="Listado Pallet Abastecidos" dark color="#0055ff"></s-toolbar>
			<!-- <v-container> -->
				<v-row>
					<v-col cols="12" lg="12" md="12">
						<!-- <v-card> -->
							<!-- <v-card-text style="height: 40px; background: #ecf5ff; -webkit-box-shadow: 2px 1px 0px 0px rgb(0 0 0 / 10%), 0px 0px 0px 0px rgb(0 0 0 / 4%), 0px 1px 0px 0px rgb(0 0 0 / 2%); border-radius: 5px; col-md-6;">
								<b>
									Listado Pallet Abastecidos
								</b>
							</v-card-text> -->
							<!-- <v-card-actions>  -->
								 <!-- <v-col cols="12" lg="12" md="12"> -->
									 <v-data-table
										dense
										:items="items"
										:headers="headers"
										:items-per-page="-1"
										hide-default-footer
										group-by="RcfID"
										:group-desc="true"
										
									>
									<!-- eslint-disable-next-line vue/valid-v-slot -->
										<template v-slot:item.LcsState={item}>
											<v-chip
												x-small
												:color="item.LcsState == 1 ? 'warning' : item.LcsState == 2 ? 'success' : 'error'"
											>
												{{item.LcsState == 1 ? 'En Proceso' : item.LcsState == 2 ? 'Abastecido' : 'Sin Abastecer'}}
											</v-chip>
										</template>
									<!-- eslint-disable-next-line vue/valid-v-slot -->
										<template v-slot:item.LcsEnabled={item}>
											<v-btn
												v-if="item.LcsState == 2 &&  $fun.isAdmin()"
												x-small
												:color="'error'"
												fab
												@click="clickEnabled(item)"
											>
												<v-icon>fas fa-check-circle</v-icon>
											</v-btn>
										</template>
	
										
									</v-data-table>
								<!-- </v-col>  -->
							<!-- </v-card-actions> -->
						<!-- </v-card> -->
					</v-col>
				</v-row>
			<!-- </v-container> -->
		</v-card>
	</div>
</template>

<script>
	import _sLotProdCalibratedSupplyService from "../../../services/FreshProduction/PrfLotProdCalibratedSupplyService";
	import sTurnInProcess from "@/components/FreshProduction/Turn/sTurnInProcess.vue"
	import signalr from "signalr";

	export default {
		components: {sTurnInProcess},
		data: () => ({
			items: [],
			headers: [
				{ text: "OP", value: "LcsEnabled" },
				{ text: "Id.", value: "LcsID" },
				{ text: "LP", value: "RcfID" },
				{ text: "N° Guia Cosecha", value: "RcfNumberHarvestGuide" },
				{ text: "N° Parihuela.", value: "WpbNumberPallet" },
				{ text: "Cant. Abast.", value: "LcsAmountSupply" },
				{ text: "Variedad", value: "VrtName" },
				{ text: "Cultivo", value: "TypeCultiveName" },
				{ text: "Tipo Cultivo", value: "TypeCropName" },
				{ text: "Calibradora", value: "TypeCalibratorName" },
				{ text: "Tina", value: "TypeTubName" },
				{ text: "Fecha/Hora", value: "SecCreate", width: 150 },
				{ text: "Estado", value: "LcsState" },
			],
			RcfID: 0,
			TrnID: 0,
			CmaId:0,
		}),

		created() {
			this.clickSearch()
		},

		watch:{
			
			TrnID(){
				if(this.TrnID == null){
					this.TrnID = 0
				}
				
				this.clickSearch()
			},
			CmaId(){
				if(this.CmaId == null){
					this.CmaId = 0
				}
				
				this.clickSearch()
			}
		},

		methods: {
			clickSearch() {

				let filter = {
					CmaId: this.CmaId,
					RcfID: this.RcfID,
					TrnID: this.TrnID,
				}

				_sLotProdCalibratedSupplyService
					.GetPalletSupply(1, this.RcfID, this.TrnID, this.$fun.getUserID())
					.then(resp => {
						if (resp.status == 200) {
							this.items = resp.data;
							this.items.forEach(element => {
								if(element.TypeCalibratorName !== null){
									element.SecCreate = this.$moment(element.SecCreate).format(this.$const.FormatDateTimeDB);
								}
								
							});
							//this.$refs.rcffocus.focus();
						}
					});
			},

			clickEnabled(item){
				console.log("enabled", item);

				this.$fun.alert("¿Seguro de desabastecer Parihuela ?", "question").then(val => {
					if(val.value){
						_sLotProdCalibratedSupplyService.anulateParihuela(item, this.$fun.getUserID()).then(resp => {
							if(resp.status == 200){
								this.clickSearch()
							}
						})
					}
				})
			}
		},

		mounted() {
			let recaptchaScript = document.createElement("script");
			recaptchaScript.setAttribute("src", this.$const.URL + "/signalr/hubs");
			document.head.appendChild(recaptchaScript);

			recaptchaScript.addEventListener("load", () => {
				$.connection.hub.url = this.$const.URL + "/signalr";
				var chat = $.connection.notification;
				chat.client.SendMessageSupplyCalibrator = group => {
					this.clickSearch()
				};

				$.connection.hub.start({ jsonp: true }).done(e => {
					chat.invoke("addToGroup", "updateWaitingsupplycalibrator");
				});
			});
		},
	};
</script>
